import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    overflow: 'hidden',
  },
  tableTitle: {
    textTransform: 'uppercase',
    letterSpacing: '0.1rem',
    font: { size: '1.8rem', lineHeight: '2.4rem', weight: 700 },
    color: colors.neutral[700],
  },
  tableBody: {
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    padding: '1.6rem 0rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
      paddingRight: '1rem',
      width: '30%',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
      width: '20%',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
